import { render, staticRenderFns } from "./timeSheetPriceBox.vue?vue&type=template&id=63213000&"
import script from "./timeSheetPriceBox.vue?vue&type=script&lang=ts&"
export * from "./timeSheetPriceBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports